import React, { useEffect } from 'react';
import Hero from './Hero';
import HowWorks from './HowWorks';
import ComparisonTable from './ComparisonTable';
import CTABanner from './CTABanner';
import Footer from '../../Footer';

const BiometricPayrollPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ fontFamily: "'Montserrat', Helvetica, Arial, sans-serif" }}>
      <Hero />
      <HowWorks />
      <ComparisonTable />
      <CTABanner />
      <Footer />
    </div>
  );
}

export default BiometricPayrollPage;
